"use strict";
var r, e;
function o() {
  return e || (e = 1, r = Math.pow), r;
}
export {
  o as __require
};
//# sourceMappingURL=index.es314.js.map
